import { c as _c } from "react/compiler-runtime";
export default function ProfileActivityLogsGeneralCICStatementIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="tw-flex-shrink-0 tw-h-4 tw-w-4 tw-text-iron-100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}